import { useAxiosState } from './useAxios';

const sprintUrl = `${process.env.REACT_APP_BACKEND}/closedSprints?boardNumber=1205`;

export interface Ticket {
  jiraKey: string;
  title: string;
  type: string;
  description: string;
}

export function useTickets() {
  const { value: tickets, status, error } = useAxiosState<Ticket[]>([], sprintUrl);

  return { tickets, status, error };
}
